









































































































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import LendingInterestSettings from '@/models/Products/ProductSettings/DefaultSettings/LendingInterest/LendingInterestSettings';
import LendingInterestSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/LendingInterest/LendingInterestSettingsEditDialog.vue';
import InterestRateType from '@/models/Products/InterestRateType';
import PeriodType from '@/models/Shared/PeriodType';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'LendingInterestSettingsRead', components: { ProductState, LendingInterestSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    InterestRateType = InterestRateType;
    PeriodType = PeriodType;
    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: LendingInterestSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }

}
